export function facebookShareUrl(url) {
  return `http://www.facebook.com/share.php?u=${encodeURIComponent(url)}`;
}

export function twitterShareUrl(url, copy) {
  const shareUrl = encodeURIComponent(url);
  const text = encodeURIComponent(copy);
  const params = `?text=${text}&url=${shareUrl}`;
  return `https://twitter.com/intent/tweet${params}`;
}

export function trackEvent({ category, action = 'click', label}) {
  if (window.ga) {
    window.ga(`send`, `event`, {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    });
  }
}